import styled from 'styled-components';

export const DropdownSeparator = styled.div`
  padding: 8px 16px;

  &:after {
    content: '';
    display: block;
    border-top-width: 1px;
    border-top-style: solid;
  }
`;
